import type { Processor } from '@app/store/middleware/processorMiddleware.js';
import { dataViewerSetData } from '@features/dataViewer/model/actions.js';
import { fitMapToBbox } from '@features/map/fitMapToBbox.js';
import bbox from '@turf/bbox';

export const dataViewerSetTrackDataProcessor: Processor<
  typeof dataViewerSetData
> = {
  actionCreator: dataViewerSetData,
  transform: ({ action, dispatch }) => {
    const { focus, trackGeojson } = action.payload;

    if (focus && trackGeojson) {
      let bounds;

      try {
        bounds = bbox(trackGeojson);
      } catch {}

      if (bounds) {
        fitMapToBbox(dispatch, [bounds[0], bounds[1], bounds[2], bounds[3]]);
      }
    }

    return action;
  },
};
